"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Button = _interopRequireDefault(require("../Button"));

var _Trigger = _interopRequireDefault(require("../Trigger"));

var _Menu = _interopRequireDefault(require("./Menu"));

var _style = _interopRequireDefault(require("./style"));

var _FaceWrapper = _interopRequireDefault(require("./components/FaceWrapper"));

var _Item = _interopRequireDefault(require("./components/Item"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);
var defaultLabels = {
  selectAll: 'Select all',
  searchInput: 'Search'
};
/**
 * ExtensibleDropdown component to select value from options.
 */

var ExtensibleDropdown = function ExtensibleDropdown(_ref) {
  var id = _ref.id,
      options = _ref.options,
      selected = _ref.selected,
      children = _ref.children,
      className = _ref.className,
      onSelect = _ref.onSelect,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$closeOnOutsideCl = _ref.closeOnOutsideClick,
      closeOnOutsideClick = _ref$closeOnOutsideCl === void 0 ? false : _ref$closeOnOutsideCl,
      menuClassName = _ref.menuClassName,
      titleClassName = _ref.titleClassName,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      _ref$searchable = _ref.searchable,
      searchable = _ref$searchable === void 0 ? true : _ref$searchable,
      onToggle = _ref.onToggle,
      onFilterChange = _ref.onFilterChange,
      onSelectAll = _ref.onSelectAll,
      disableSelectAll = _ref.disableSelectAll,
      open = _ref.open,
      total = _ref.total,
      _ref$initialAllSelect = _ref.initialAllSelected,
      initialAllSelected = _ref$initialAllSelect === void 0 ? false : _ref$initialAllSelect,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$clickableChildID = _ref.clickableChildIDs,
      clickableChildIDs = _ref$clickableChildID === void 0 ? [] : _ref$clickableChildID,
      faceText = _ref.faceText,
      selectedText = _ref.selectedText,
      labels = _ref.labels,
      disableAllUnselected = _ref.disableAllUnselected,
      offsetBy = _ref.offsetBy,
      loadMore = _ref.loadMore,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["id", "options", "selected", "children", "className", "onSelect", "defaultOpen", "closeOnOutsideClick", "menuClassName", "titleClassName", "kind", "searchable", "onToggle", "onFilterChange", "onSelectAll", "disableSelectAll", "open", "total", "initialAllSelected", "loading", "clickableChildIDs", "faceText", "selectedText", "labels", "disableAllUnselected", "offsetBy", "loadMore"]);
  var classes = useStyles();

  var _React$useState = React.useState(defaultOpen || false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      internalOpen = _React$useState2[0],
      setInternalOpen = _React$useState2[1];

  var _React$useState3 = React.useState(''),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      filterString = _React$useState4[0],
      setLocalFilterString = _React$useState4[1];

  var menuID = "".concat(id, "-MENU");
  React.useEffect(function () {
    if (internalOpen && typeof open !== 'undefined') setInternalOpen(open || false);
  }, [open, internalOpen]);

  var _toggle = function _toggle(open) {
    setInternalOpen(open);

    if (onToggle) {
      onToggle(open);
    }
  };

  var _handleFaceClick = function _handleFaceClick() {
    _toggle(!internalOpen);
  }; // eslint-disable-next-line complexity


  var _handleOutsideClick = function _handleOutsideClick(e) {
    var path = e.path || e.composedPath && e.composedPath();
    var parentIDs = [menuID].concat((0, _toConsumableArray2["default"])(clickableChildIDs)); // In tests using react-testing-library, then clicking outside a component yields a mouse event and does not have
    // any path, unlike in the real world where there is a pointer event with path.

    if (!path) {
      return;
    }

    if (closeOnOutsideClick && !path.filter(function (el) {
      return parentIDs.includes(el.id);
    }).length) _toggle(false);
  };

  var formatFace = function formatFace(selected) {
    return faceText || (selected.length ? "".concat(selected.length, " selected") : 'All');
  };

  return /*#__PURE__*/React.createElement(_Trigger["default"], {
    open: internalOpen,
    face: /*#__PURE__*/React.createElement(_Button["default"].Lite, (0, _extends2["default"])({}, rest, {
      id: id,
      "data-test-id": id,
      className: (0, _classnames["default"])(classes.BaseAlign, (0, _defineProperty2["default"])({}, classes.KindLite, kind === 'lite'), className),
      onClick: _handleFaceClick,
      active: internalOpen,
      style: {
        width: 160
      }
    }), /*#__PURE__*/React.createElement(_FaceWrapper["default"], {
      left: formatFace(selected),
      leftClassName: (0, _classnames["default"])(classes.Title, titleClassName),
      right: "\u25BE",
      minSpace: 10
    })),
    positionVertical: 'left',
    positionHorizontal: 'top',
    onOutsideClick: _handleOutsideClick,
    relativeOffset: 2,
    constraints: [{
      to: 'window',
      attachment: 'together'
    }],
    classes: {
      element: classes.tetherElement
    }
  }, /*#__PURE__*/React.createElement(_Menu["default"], {
    options: options || [],
    selected: selected,
    id: menuID,
    "data-test-id": menuID,
    className: menuClassName,
    "data-overlay-menu": true,
    "data-overlay-for": id,
    onFilterChange: onFilterChange,
    onSelectAll: onSelectAll,
    disableSelectAll: disableSelectAll,
    onItemClick: onSelect,
    searchable: searchable,
    total: total,
    initialAllSelected: initialAllSelected,
    loading: loading,
    filterString: filterString,
    setLocalFilterString: setLocalFilterString,
    selectedText: selectedText,
    labels: _objectSpread(_objectSpread({}, defaultLabels), labels),
    disableAllUnselected: disableAllUnselected,
    offsetBy: offsetBy,
    loadMore: loadMore
  }, children));
};

exports["default"] = ExtensibleDropdown;
ExtensibleDropdown.Item = _Item["default"];
//# sourceMappingURL=index.js.map